/* CUSTOM_CFALOGOREVIEW_BY_CLAUDE (Ryan 2026-11-02, CFA Outbound Campaign 1, Step 4) - the CFA LOGO REVIEW page.
   Planner: Team-Portal-Bot/tools/CFA-Logo-Review/CFA-LOGO-REVIEW-PLANNER.md (team-portal-docs).

   One school at a time: its logo on a 45 lb urethane bumper, drawn by the real Weight Designer in the weekly batch.
   Phill decides: Yes (keep) - or This / That when the Solid and See-through versions differ - No (an optional one-key
   reason), Try another (the logo fetch's runner-ups), Upload. Auto-advance, a progress bar, doubtful cards first and
   no-logo schools last (the worker sorts). (!) Only a Keep makes a school send-ready.

   KEYS (Ryan 2026-11-03: "Y and N ... closer together and easier to manage when trying to get through hundreds"):
     Y yes / keep          1, 2 keep This / That (or click the plate)
     N no -> then N again (no reason) or 1-5 (a reason)
     T try another -> 1-4 pick     U upload     Z undo     <- -> back / next     Esc close a panel

   Reads/writes rfq-worker: GET /cfa-logo-review, GET /cfa-logo-review/img (a picture, fetched with the bearer and shown
   as a blob URL), POST /cfa-logo-review/verdict, POST /cfa-logo-review/upload. CFA + admin only; the worker is the gate.
   (!) This file is plain ASCII on purpose: non-ASCII text is written as \u escapes (served without a charset once,
   the separators came out garbled). */
(function () {
  'use strict';

  var WORKER = 'https://rfq-worker.ryan-29b.workers.dev'; // = WORKER_BASE in custom-rep-portal.js (images need a raw fetch)

  /* (!) THE FLAGS IN PLAIN ENGLISH (Ryan 2026-11-03: "I have no idea what 'failed the automatic logo checks' even
     means"). The batch now writes these words itself (cfa_logo_batch.py); this map translates the older wording still
     on records drawn before that, so no card shows the jargon. */
  var OLD_FLAG_WORDS = {
    'Failed the automatic logo checks': 'Picked as a last resort: no picture on their site passed our logo checks',
    'Fills its whole frame (photo?)': 'Fills its whole frame, so it may be a photo rather than a logo',
    'Small file': 'Small image, so it may print soft',
    'Very small file': 'Tiny image (under 200 px), so it may print blurry',
    'Wide logo with words': 'Wide logo with words beside it, so it may read small on a plate',
    'Same picture as other schools': 'Other schools\' sites use the same picture, so it is probably not theirs',
    'Hard to read its colours': 'Its colours are hard to read',
    'Colours don\'t match the school\'s': 'Its colours do not match the school\'s colours',
    'The Weight Designer thinks this is a photo': 'The Weight Designer thinks this is a photo, not a logo',
    'The drawing ran into trouble': 'Something went wrong drawing it, so check the plate closely',
  };
  function flagWords(f) { return OLD_FLAG_WORDS[f] || f; }

  // -- pure helpers (exposed for tests) --
  function fmtDay(iso) {
    var t = Date.parse(iso || '');
    if (!isFinite(t)) return 'never';
    return new Date(t).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }
  /** "Last batch" words + whether to warn. Pure. */
  function batchLine(lb) {
    if (!lb || !lb.at) return { text: 'The weekly logo batch has not run yet.', warn: true };
    var d = lb.days;
    var ago = d === 0 ? 'today' : d === 1 ? 'yesterday' : d + ' days ago';
    if (lb.stale) {
      return { text: 'Last batch ' + fmtDay(lb.at) + ' (' + ago + '). It runs every Monday and is late, so new logos, uploads and "try another" picks are waiting on it.', warn: true };
    }
    return { text: 'Last batch ' + fmtDay(lb.at) + ' (' + ago + '). Uploads and "try another" picks come back after the next one, every Monday.', warn: false };
  }
  /** How many are decided (kept or rejected) out of all. Pure. */
  function progress(counts) {
    var total = (counts && counts.total) || 0;
    var done = ((counts && counts.approved) || 0) + ((counts && counts.rejected) || 0);
    return { done: done, total: total, pct: total ? Math.round(done * 100 / total) : 0 };
  }
  /** The versions a card offers, in This / That order. Pure. */
  function versionsOf(s) {
    var p = (s && s.plates) || {};
    if (p.solid && p.see) return ['solid', 'see'];
    if (p.only) return ['only'];
    return Object.keys(p);
  }
  function inFilter(s, f) { return f === 'all' || s.status === f; }

  // -- DOM --
  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    for (var k in (attrs || {})) {
      var v = attrs[k];
      if (v == null || v === false) continue;
      if (k === 'text') n.textContent = v;
      else if (k === 'class') n.className = v;
      else if (k.slice(0, 2) === 'on') n.addEventListener(k.slice(2), v);
      else n.setAttribute(k, v === true ? '' : v);
    }
    (kids || []).forEach(function (c) { if (c != null) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }
  function kbd(k) { return el('span', { class: 'clr-kbd', 'aria-hidden': 'true', text: k }); }
  function api() { return window.RepPortal && window.RepPortal.API; }

  var root, data = null, filter = 'pending', idx = 0, panel = null, busy = false, lastAction = null, toast = null;
  var blobs = {};   // r2 key -> object URL

  function img(key, cls, alt) {
    var node = el('img', { class: cls, alt: alt || '', draggable: 'false' });
    if (!key) return node;
    loadBlob(key).then(function (u) { if (u) node.src = u; }).catch(function () { node.classList.add('clr-img--broken'); });
    return node;
  }
  function loadBlob(key) {
    if (blobs[key]) return Promise.resolve(blobs[key]);
    var auth = window.RepPortal && window.RepPortal.Auth;
    return (auth ? auth.getAccessToken() : Promise.resolve(null)).then(function (tok) {
      return fetch(WORKER + '/cfa-logo-review/img?key=' + encodeURIComponent(key), { headers: { Authorization: 'Bearer ' + tok } });
    }).then(function (r) {
      if (!r.ok) throw new Error('image ' + r.status);
      return r.blob();
    }).then(function (b) { blobs[key] = URL.createObjectURL(b); return blobs[key]; });
  }
  function prefetch(list, from) {
    for (var i = from; i < Math.min(list.length, from + 3); i++) {
      var s = list[i];
      versionsOf(s).forEach(function (v) { if (!blobs[s.plates[v]]) loadBlob(s.plates[v]).catch(function () {}); });
      if (s.logo && !blobs[s.logo]) loadBlob(s.logo).catch(function () {});
    }
  }

  function list() { return data ? data.schools.filter(function (s) { return inFilter(s, filter); }) : []; }

  function say(msg, kind) {
    if (!toast) return;
    toast.textContent = msg;
    toast.className = 'clr-toast' + (kind ? ' clr-toast--' + kind : '') + ' is-on';
    clearTimeout(say._t);
    say._t = setTimeout(function () { toast.classList.remove('is-on'); }, 3200);
  }

  // -- render --
  function render() {
    root.innerHTML = '';
    var c = data.counts || {};
    var pr = progress(c);
    var bl = batchLine(data.lastBatch);
    root.appendChild(el('p', { class: 'clr-health' + (bl.warn ? ' clr-health--warn' : ''), role: bl.warn ? 'alert' : null }, [
      el('span', { class: 'clr-health__dot', 'aria-hidden': 'true' }), el('span', { text: bl.text }),
    ]));
    root.appendChild(el('div', { class: 'clr-tiles' }, [
      el('div', { class: 'clr-tile clr-tile--hero' }, [
        el('span', { class: 'clr-tile__label', text: 'Decided' }),
        el('span', { class: 'clr-tile__value', text: pr.done + ' of ' + pr.total }),
        el('div', { class: 'clr-bar', role: 'progressbar', 'aria-valuemin': '0', 'aria-valuemax': String(pr.total), 'aria-valuenow': String(pr.done) }, [
          el('div', { class: 'clr-bar__fill', style: 'width:' + pr.pct + '%' }),
        ]),
      ]),
      tile('pending', 'To review', c.pending, ''),
      tile('approved', 'Send-ready', c.sendReady, 'clr-tile--green'),
      tile('waiting', 'Waiting on batch', c.waiting, 'clr-tile--blue'),
      tile('rejected', 'Rejected', c.rejected, 'clr-tile--red'),
    ]));
    var L = list();
    if (!L.length) {
      root.appendChild(el('div', { class: 'clr-empty' }, [
        el('p', { class: 'clr-empty__title', text: filter === 'pending' ? 'Nothing left to review.' : 'Nothing here.' }),
        filter === 'pending' && (c.waiting || 0) ? el('p', { text: c.waiting + ' school' + (c.waiting === 1 ? ' is' : 's are') + ' waiting on the weekly batch to draw a new logo.' }) : null,
      ]));
      return;
    }
    if (idx >= L.length) idx = L.length - 1;
    if (idx < 0) idx = 0;
    root.appendChild(card(L[idx], idx, L.length));
    root.appendChild(el('div', { class: 'clr-nav' }, [
      el('button', { type: 'button', class: 'clr-btn clr-btn--small', disabled: idx === 0 || null, onclick: function () { go(-1); } }, [kbd('\u2190'), 'Back']),
      el('button', { type: 'button', class: 'clr-btn clr-btn--small', disabled: idx >= L.length - 1 || null, onclick: function () { go(1); } }, ['Next', kbd('\u2192')]),
    ]));
    root.appendChild(keys());
    prefetch(L, idx + 1);
  }

  function tile(id, label, n, cls) {
    return el('button', { type: 'button', class: 'clr-tile ' + cls + (filter === id ? ' is-on' : ''), 'aria-pressed': filter === id ? 'true' : 'false',
      onclick: function () { filter = filter === id ? 'all' : id; idx = 0; panel = null; render(); } }, [
      el('span', { class: 'clr-tile__label', text: label }),
      el('span', { class: 'clr-tile__value', text: String(n || 0) }),
    ]);
  }

  function swatches(names, hexes) {
    var nm = String(names || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean);
    var hx = hexes || [];
    var n = Math.max(nm.length, hx.length);
    var out = [];
    for (var i = 0; i < n; i++) {
      out.push(el('span', { class: 'clr-swatch' }, [
        hx[i] ? el('span', { class: 'clr-swatch__dot', style: 'background:' + hx[i], title: hx[i] }) : null,
        nm[i] ? el('span', { text: nm[i] }) : null,
      ]));
    }
    return el('div', { class: 'clr-swatches' }, out);
  }

  function card(s, i, n) {
    var vers = versionsOf(s);
    var pair = vers.length === 2;
    var pending = s.status === 'pending';
    var stage = el('div', { class: 'clr-stage' + (pair ? ' clr-stage--pair' : '') }, vers.length ? vers.map(function (v, k) {
      var cap = pair ? el('span', { class: 'clr-plate__cap' }, [kbd(String(k + 1)), (k === 0 ? 'This' : 'That'),
        el('span', { class: 'clr-plate__sub', text: v === 'solid' ? 'solid' : 'see-through' })]) : null;
      var kids = [img(s.plates[v], 'clr-plate__img', s.school + ' logo on a 45 lb bumper'), cap];
      // a pair's plate IS its button: clicking the one you want keeps it
      return pair && pending
        ? el('button', { type: 'button', class: 'clr-plate', title: 'Keep this one', onclick: function () { act(s, { action: 'keep', version: v }); } }, kids)
        : el('figure', { class: 'clr-plate' }, kids);
    }) : [el('div', { class: 'clr-noplate' }, [
      el('p', { class: 'clr-noplate__title', text: 'No logo on a plate yet' }),
      el('p', { text: s.note || 'No logo was found on the school\'s website.' }),
      el('p', { text: (s.runnersUp || []).length ? 'Try another shows other pictures from their site, or upload one.' : 'Upload one from their website or social media.' }),
    ])]);

    var pal = s.palette || {};
    var facts = [];
    function fact(k, v) { if (v) { facts.push(el('dt', { text: k })); facts.push(el('dd', {}, [v])); } }
    fact('Mascot', s.mascot);
    fact('State', s.state);
    fact('Athletic director', s.adName);
    fact('School colours', (s.colors || (s.colorsHex || []).length) ? swatches(s.colors, s.colorsHex) : null);
    fact('Logo colours', pal.primary ? swatches('', [pal.primary, pal.secondary].filter(Boolean)) : null);

    var side = el('div', { class: 'clr-side' }, [
      el('div', {}, [
        el('p', { class: 'clr-head__count', text: (filter === 'pending' ? 'To review: ' : '') + (i + 1) + ' of ' + n }),
        el('h2', { class: 'clr-head__name', text: s.school }),
      ]),
      !pending ? el('p', { class: 'clr-status clr-status--' + s.status, text: statusWords(s) }) : null,
      facts.length ? el('dl', { class: 'clr-facts' }, facts) : null,
      s.flags && s.flags.length ? el('div', {}, [
        el('p', { class: 'clr-section__title', text: 'Check this one closely' }),
        el('ul', { class: 'clr-flags' }, s.flags.map(function (f) { return el('li', { text: flagWords(f) }); })),
      ]) : null,
      s.logo ? el('div', {}, [
        el('p', { class: 'clr-section__title', text: 'The logo we found' }),
        el('div', { class: 'clr-found clr-checker' }, [img(s.logo, '', 'the logo as found on their site')]),
      ]) : null,
      s.round > 1 ? el('p', { class: 'clr-section__title', text: 'Drawn again after your last request' }) : null,
      el('div', { class: 'clr-actions' }, actionButtons(s, vers)),
      panel ? panelFor(s) : null,
    ]);
    return el('section', { class: 'clr-card', 'aria-label': s.school }, [stage, side]);
  }

  function statusWords(s) {
    if (s.status === 'approved') return 'Kept' + (s.verdict && s.verdict.version !== 'only' ? ' (' + (s.verdict.version === 'see' ? 'see-through' : 'solid') + ')' : '') + '. Ready to email.';
    if (s.status === 'rejected') return 'Rejected' + (s.verdict && s.verdict.reason ? ': ' + s.verdict.reason : '') + '.';
    if (s.status === 'waiting') return s.request && s.request.kind === 'upload' ? 'Waiting on the weekly batch to draw your upload.' : 'Waiting on the weekly batch to draw the logo you picked.';
    return '';
  }

  function actionButtons(s, vers) {
    if (s.status !== 'pending') {
      return [el('div', { class: 'clr-actions__row' }, [
        el('button', { type: 'button', class: 'clr-btn', onclick: function () { act(s, { action: 'undo' }); } }, ['Undo', kbd('Z')]),
      ])];
    }
    var main;
    if (vers.length === 2) {
      main = [
        el('button', { type: 'button', class: 'clr-btn clr-btn--yes', onclick: function () { act(s, { action: 'keep', version: vers[0] }); } }, ['Keep This', kbd('1')]),
        el('button', { type: 'button', class: 'clr-btn clr-btn--yes', onclick: function () { act(s, { action: 'keep', version: vers[1] }); } }, ['Keep That', kbd('2')]),
      ];
    } else if (vers.length === 1) {
      main = [el('button', { type: 'button', class: 'clr-btn clr-btn--yes', onclick: function () { act(s, { action: 'keep', version: vers[0] }); } }, ['Yes, keep', kbd('Y')])];
    } else {
      main = [];
    }
    if (vers.length) main.push(el('button', { type: 'button', class: 'clr-btn clr-btn--no', onclick: function () { openPanel('reject'); } }, ['No', kbd('N')]));
    var hasRu = (s.runnersUp || []).length > 0;
    return [
      main.length ? el('div', { class: 'clr-actions__row' }, main) : null,
      el('div', { class: 'clr-actions__row' }, [
        el('button', { type: 'button', class: 'clr-btn clr-btn--small', disabled: hasRu ? null : true, title: hasRu ? null : 'No other pictures were found on their site',
          onclick: function () { openPanel('another'); } }, [hasRu ? 'Try another' : 'No others found', hasRu ? kbd('T') : null]),
        el('button', { type: 'button', class: 'clr-btn clr-btn--small', onclick: function () { pickFile(s); } }, ['Upload', kbd('U')]),
      ]),
    ];
  }

  function openPanel(kind) { panel = panel === kind ? null : kind; render(); }

  function panelFor(s) {
    if (panel === 'reject') {
      return el('div', { class: 'clr-panel' }, [
        el('p', { class: 'clr-panel__title', text: 'Why not? Press N again to skip the reason.' }),
        el('div', { class: 'clr-reasons' }, (data.reasons || []).map(function (r, k) {
          return el('button', { type: 'button', class: 'clr-reason', onclick: function () { act(s, { action: 'reject', reason: r }); } }, [kbd(String(k + 1)), r]);
        }).concat([el('button', { type: 'button', class: 'clr-reason', onclick: function () { act(s, { action: 'reject' }); } }, [kbd('N'), 'No reason'])])),
      ]);
    }
    if (panel === 'another') {
      return el('div', { class: 'clr-panel' }, [
        el('p', { class: 'clr-panel__title', text: 'Other pictures from their site. Pick one and Monday\'s batch puts it on a plate for you.' }),
        el('div', { class: 'clr-ru-grid' }, (s.runnersUp || []).map(function (r, k) {
          return el('button', { type: 'button', class: 'clr-ru clr-checker', title: r.url || '', onclick: function () { act(s, { action: 'runner-up', idx: k }); } }, [
            img(r.img, 'clr-ru__img', 'option ' + (k + 1)), kbd(String(k + 1)),
          ]);
        })),
      ]);
    }
    return null;
  }

  function keys() {
    function k(key, words) { return el('span', {}, [kbd(key), words]); }
    return el('div', { class: 'clr-keys', 'aria-label': 'Keyboard shortcuts' }, [
      k('Y', 'yes, keep'), k('N', 'no'), k('1 / 2', 'keep This / That'), k('T', 'try another'), k('U', 'upload'),
      k('Z', 'undo'), k('\u2190 \u2192', 'back / next'),
    ]);
  }

  // -- actions --
  function replace(school) {
    for (var i = 0; i < data.schools.length; i++) if (data.schools[i].id === school.id) data.schools[i] = school;
    var c = { total: data.schools.length, pending: 0, approved: 0, rejected: 0, waiting: 0, sendReady: 0 };
    data.schools.forEach(function (s) { c[s.status] = (c[s.status] || 0) + 1; if (s.status === 'approved') c.sendReady++; });
    data.counts = c;
  }

  function act(s, body) {
    if (busy) return;
    busy = true;
    var wasIdx = idx;
    body.id = s.id;
    api().fetch('/cfa-logo-review/verdict', { method: 'POST', body: JSON.stringify(body) }).then(function (res) {
      replace(res.school);
      panel = null;
      if (body.action === 'undo') {
        lastAction = null;
        filter = 'pending';
        idx = Math.max(0, list().map(function (x) { return x.id; }).indexOf(s.id));
        say('Undone. ' + s.school + ' is back in the queue.');
      } else {
        lastAction = { id: s.id, school: s.school };
        // auto-advance: in "To review" the same position now holds the next school (this one left the list)
        idx = filter === 'pending' ? wasIdx : wasIdx + 1;
        say(words(body, s) + '  Z to undo.', body.action === 'reject' ? 'warn' : 'ok');
      }
      render();
    }).catch(function (err) {
      say((err && err.message) || 'That did not save. Try again.', 'error');
    }).then(function () { busy = false; });
  }
  function words(b, s) {
    if (b.action === 'keep') return 'Kept ' + s.school + (b.version === 'see' ? ' (see-through)' : b.version === 'solid' ? ' (solid)' : '') + '.';
    if (b.action === 'reject') return 'Rejected ' + s.school + (b.reason ? ': ' + b.reason : '') + '.';
    if (b.action === 'runner-up') return 'Picked another logo for ' + s.school + '. It comes back after Monday\'s batch.';
    return 'Saved.';
  }

  function undoLast() {
    var cur = list()[idx];
    if (cur && cur.status !== 'pending') return act(cur, { action: 'undo' });
    if (!lastAction) return say('Nothing to undo.');
    var s = data.schools.filter(function (x) { return x.id === lastAction.id; })[0];
    if (s) act(s, { action: 'undo' });
  }

  function pickFile(s) {
    var inp = el('input', { type: 'file', accept: 'image/png,image/jpeg,image/webp,image/gif,image/svg+xml,.svg', style: 'display:none' });
    inp.addEventListener('change', function () {
      var f = inp.files && inp.files[0];
      inp.remove();
      if (!f) return;
      if (f.size > 4 * 1024 * 1024) return say('That file is over 4 MB; a logo is usually far smaller.', 'error');
      var rd = new FileReader();
      rd.onload = function () {
        var b64 = String(rd.result || '').split(',')[1] || '';
        busy = true;
        api().fetch('/cfa-logo-review/upload', { method: 'POST', body: JSON.stringify({ id: s.id, name: f.name, b64: b64 }) }).then(function (res) {
          replace(res.school);
          lastAction = { id: s.id, school: s.school };
          panel = null;
          say('Uploaded. Monday\'s batch puts it on a plate for you.  Z to undo.', 'ok');
          render();
        }).catch(function (err) { say((err && err.message) || 'The upload did not save.', 'error'); })
          .then(function () { busy = false; });
      };
      rd.readAsDataURL(f);
    });
    document.body.appendChild(inp);
    inp.click();
  }

  function go(d) { idx += d; panel = null; render(); }

  function onKey(e) {
    if (!data || busy) return;
    var t = e.target && e.target.tagName;
    if (t === 'INPUT' || t === 'TEXTAREA' || t === 'SELECT' || e.metaKey || e.ctrlKey || e.altKey) return;
    var s = list()[idx];
    var k = String(e.key || '').toLowerCase();
    if (k === 'arrowright') { e.preventDefault(); if (idx < list().length - 1) go(1); return; }
    if (k === 'arrowleft') { e.preventDefault(); if (idx > 0) go(-1); return; }
    if (k === 'escape') { if (panel) { panel = null; render(); } return; }
    if (k === 'z') { e.preventDefault(); undoLast(); return; }
    if (!s || s.status !== 'pending') return;
    var vers = versionsOf(s);
    var n = parseInt(k, 10);
    if (panel === 'reject') {
      if (n >= 1 && n <= (data.reasons || []).length) { e.preventDefault(); act(s, { action: 'reject', reason: data.reasons[n - 1] }); }
      else if (k === 'n' || k === 'enter') { e.preventDefault(); act(s, { action: 'reject' }); }
      return;
    }
    if (panel === 'another') {
      if (n >= 1 && n <= (s.runnersUp || []).length) { e.preventDefault(); act(s, { action: 'runner-up', idx: n - 1 }); }
      return;
    }
    if (k === 'y' && vers.length === 1) { e.preventDefault(); act(s, { action: 'keep', version: vers[0] }); }
    else if (k === 'y' && vers.length === 2) { say('This logo comes two ways: press 1 for This or 2 for That.'); }
    else if ((k === '1' || k === '2') && vers.length === 2) { e.preventDefault(); act(s, { action: 'keep', version: vers[n - 1] }); }
    else if (k === 'n' && vers.length) { e.preventDefault(); openPanel('reject'); }
    else if (k === 't' && (s.runnersUp || []).length) { e.preventDefault(); openPanel('another'); }
    else if (k === 'u') { e.preventDefault(); pickFile(s); }
  }

  function load() {
    root.innerHTML = '';
    root.appendChild(el('p', { class: 'clr-loading', text: 'Loading the logo queue...' }));
    api().get('/cfa-logo-review').then(function (d) {
      data = d;
      render();
    }).catch(function (err) {
      root.innerHTML = '';
      var msg = err && err.status === 403 ? 'The logo review is for the CFA and admins.' : 'The logo queue could not load' + (err && err.message ? ' (' + err.message + ')' : '') + '. This is a loading problem, not an empty queue.';
      root.appendChild(el('div', { class: 'clr-empty', role: 'alert' }, [
        el('p', { class: 'clr-empty__title', text: msg }),
        err && err.status === 403 ? null : el('button', { type: 'button', class: 'clr-btn', text: 'Try again', onclick: load }),
      ]));
    });
  }

  var booted = false;
  function boot() {
    if (booted) return;
    root = document.getElementById('cfa-logo-review-root');
    if (!root || !api()) return;
    var sess = null;
    try { sess = JSON.parse(sessionStorage.getItem('rep_portal_session') || 'null'); } catch (e) { sess = null; }
    if (!sess) return;
    booted = true;
    toast = el('div', { class: 'clr-toast', role: 'status', 'aria-live': 'polite' });
    document.body.appendChild(toast);
    document.addEventListener('keydown', onKey);
    load();
  }

  window.CfaLogoReview = { _pure: { batchLine: batchLine, progress: progress, versionsOf: versionsOf, inFilter: inFilter, flagWords: flagWords } };
  if (typeof document !== 'undefined' && document.addEventListener) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    window.addEventListener('rep-portal:authenticated', boot);
  }
})();
/* END CUSTOM_CFALOGOREVIEW_BY_CLAUDE */
